import React, { Component } from 'react';
import Navigation from "../Navigation/Navigation";
import Footer from "../General/Footer";
import StarRatings from 'react-star-ratings';
import Form from 'react-bootstrap/Form';
import StarRatingComponent from 'react-star-rating-component';
import { Button } from 'react-bootstrap';
import { getRating, setRating } from '../../actions/rateActions'

export default class RateRide extends Component {

    constructor(props) {
        super(props)

        this.state = {
            rating: 1,
            title: '',
            done: false,
            bad: false
        };
        this.onStarClick = this.onStarClick.bind(this)
        this.onClickRate = this.onClickRate.bind(this)
    }


    componentDidMount() {
            getRating(this.props.match.params.rateId).then((data) => {
                if(!data){
                    this.setState({ bad: true });
                    return
                }
                this.setState({ title: data.data.title });
        }) 
    }

    onClickRate() {
        setRating(this.props.match.params.rateId, this.state.rating)
        this.setState({ done: true });
    }

    onStarClick(nextValue, prevValue, name) {
        this.setState({ rating: nextValue });
    }
    render() {
        if(this.state.bad)
            return(
                <div className="rateride__main">
                <Navigation />
                <div className="page__hero">
                    <h4 className="page-title page__hero__title">Rate your ride</h4>
                </div>
                <div className="rateride__container">
                    <div className="rateride__fields__container">
                        <Form.Label className="createride__category__title">This ride already been rated or don't exist</Form.Label><br />
                    </div>
                </div>
                <Footer />
            </div>
            )
        else if (!this.state.done)
            return (
                <div className="rateride__main">
                    <Navigation />
                    <div className="rateride__hero">
                        <h4 className="rides-title rateride__hero__title">Rate your ride</h4>
                    </div>
                    <div className="rateride__container">
                        <div className="rateride__fields__container">
                            <Form.Label className="createride__category__title">Rate the ride : {this.state.title}</Form.Label><br />
                            <p>How was your ride? Was the owner good.</p>
                            <div>
                                <StarRatingComponent
                                    name="rate1"
                                    starCount={5}
                                    value={this.state.rating}
                                    onStarClick={this.onStarClick.bind(this)}
                                />
                            </div>
                            <div>
                                <Button variant="primary" type="button" onClick={this.onClickRate}>Send</Button>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        else
            return (
            <div className="rateride__main">
                <Navigation />
                <div className="rateride__hero">
                    <h4 className="rides-title rateride__hero__title">Rate your ride</h4>
                </div>
                <div className="rateride__container">
                    <div className="rateride__fields__container">
                        <Form.Label className="createride__category__title">Thanks for rating the ride : {this.state.title}</Form.Label><br />
                    </div>
                </div>
                <Footer />
            </div>)

    }
}
